"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetApiInterface = exports.ApiInterface = exports.WidgetApi = exports.FormApi = exports.IApi = exports.DatasheetApi = exports.Api = exports.Url = exports.DashboardApi = void 0;
// core/api is a compatible layer after modularize
const Api = __importStar(require("../../modules/shared/api/api"));
exports.Api = Api;
const Url = __importStar(require("../../modules/shared/api/url"));
exports.Url = Url;
const DatasheetApi = __importStar(require("../../modules/database/api/datasheet_api"));
exports.DatasheetApi = DatasheetApi;
const IApi = __importStar(require("../../modules/shared/api/api.interface"));
exports.IApi = IApi;
const FormApi = __importStar(require("../../modules/database/api/form_api"));
exports.FormApi = FormApi;
const WidgetApi = __importStar(require("../../modules/widget/api/widget_api"));
exports.WidgetApi = WidgetApi;
const ApiInterface = __importStar(require("../../modules/shared/api/api.interface"));
exports.ApiInterface = ApiInterface;
const WidgetApiInterface = __importStar(require("../../modules/widget/api/widget_api.interface"));
exports.WidgetApiInterface = WidgetApiInterface;
exports.DashboardApi = __importStar(require("../../modules/database/api/dashboard_api"));
__exportStar(require("../../modules/database/api/datasheet_api.interface"), exports);
//# sourceMappingURL=index.js.map